module.exports = __webpack_public_path__ + "img/fbb26fc.png";